module.exports = __webpack_public_path__ + "img/Cert 03.4d8da320.png";